import { createSelector } from 'reselect';

import socketSelectors from './socketSelectors';

const selectCommunication = state => state.communication;
const selectRequestContact = createSelector(selectCommunication, state => state.requestContact);

export default {
  selectCommunication,
  isAgent: createSelector(selectCommunication, state => state.isAgent),
  isCenterActive: createSelector(selectCommunication, state => state.isCenterActive),
  isAnonymous: createSelector(selectCommunication, state => state.isAnonymous),
  getAnonymous: createSelector(selectCommunication, state => state.anonymous),
  isRequestContactPending: createSelector(selectRequestContact, state => state.pending),
  getRequestContactResponse: createSelector(selectRequestContact, state => state.response),
  isRequestContactSucceeded: createSelector(selectRequestContact, state => state.succeeded),
  hasRequestContactError: createSelector(selectRequestContact, state => !!state.error),
  getRequestContactError: createSelector(selectRequestContact, state => state.error),
  isInactive: createSelector(selectCommunication, state => state.hasInactivityWarning),
  getCustomerChat: createSelector(selectCommunication, state => state.customerChat),
  getReviewData: createSelector(selectCommunication, state => state.reviewData),
  isReviewPending: createSelector(selectCommunication, state => state.reviewPending),
  socket: socketSelectors,
};
